<app-customers-pricing-table [title] = "'PRICING.PRICING_LISTS'" [pricingLists] = true></app-customers-pricing-table>
